import { render, staticRenderFns } from "./VendorUpsertComponent.vue?vue&type=template&id=26c6693d&"
import script from "./VendorUpsertComponent.vue?vue&type=script&lang=ts&"
export * from "./VendorUpsertComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports